jQuery(document).ready(function($) {

    var more    = '<p><!--more--></p>'; 
    var regex   = new RegExp(more, 'g');

    $('.wysiwyg').each(function() {
        var content     = $(this).html();
        var lang        = $('html').attr("lang"); 
        var more_text   = 'Lire la suite';
        if(lang=='en-GB') more_text   = 'Show more';
        let checkMatch  = content.match(regex);
        if (checkMatch != null) {
            var newContent          = content.replace(regex, 'showmore_wami');
            var myArray             = newContent.split('showmore_wami'); 
            var visible_content     = myArray[0];
            var more_content        = '<a class="js-wysiwyg-loadmore link link-blue" href="#">'+more_text+'</a><div class="c-wysiwyg-more">';
            $.each(myArray, function(index, value) { if(index>0){more_content += value;} });
            more_content            += '</div>';
            $(this).html(visible_content+more_content);     
        } 
    });

    $('body').on('click', '.js-wysiwyg-loadmore', function(e){
        e.preventDefault();
        $(this).hide().parents('.wysiwyg').find('.c-wysiwyg-more').slideDown();
    })  
    
});